const monthTitles = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export default (startDate: Date, endDate: Date) => {
  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();
  const isMonthsTransition = startMonth !== endMonth;

  return isMonthsTransition
    ? `${monthTitles[startMonth]} - ${monthTitles[endMonth]}`
    : monthTitles[startMonth];
};
